import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import { chartSettingsFormSchema, Sizes } from "./constants";
import { AdvancedChartProps, chartSettingsType } from "./types";

export const details = {
  name: "AdvancedChart",
  description: "A chart with advanced features",
  tags: ["Data"],
  category: "Advanced",
  grid: Sizes,
  setup: lazy(() => import("./Setup").then(m => ({ default: m.Setup }))),
  defaultProps: {
    mapping: {
      ...chartSettingsFormSchema.parse({
        title: "Custom Chart",
        type: "bar",
        responseShape: "general",
        dataSeriesField: "",
        labelsArrayField: "",
        labelsDeepFieldKey: "",
        labelsTransformation: "none",
        datasets: [
          {
            indexAxis: "x",
            label: "Dataset 1",
            dataArrayField: "",
            dataFieldKey: "",
            dataGrouping: "none",
            backgroundColor: "rgba(54, 162, 235, 0.5)",
            borderColor: "rgb(54, 162, 235)",
            color: "rgb(54, 162, 235)",
          },
        ],
        datasetArrayField: null,
        titleFieldKey: null,
        titleTransformation: null,
        dataAndLabelArrayFieldKey: null,
        timeSeriesFieldKey: null,
        labelTransformation: null,
        options: {
          type: "bar",
          plugins: {
            legend: {
              display: true,
              position: "top",
            },
          },
          scales: {
            x: {
              stacked: false,
              beginAtZero: true,
            },
            y: {
              stacked: false,
              beginAtZero: true,
            },
          },
        },
      } as chartSettingsType),
      requestId: "",
    },
  },
} as ElementDetails<AdvancedChartProps>;
